import { TextChannelKey } from 'types'
import { useTierFeatureGate } from './useTierFeatureGate'
import { isMultipostType } from 'components/Wizards/Catalogue/Sections/utils'

export const useNeedsUpgradeForChannelType = () => {
  const {
    featureDisabled: isMultiPostDisabled,
    nextTierPlan,
    currentTierPlan,
  } = useTierFeatureGate({
    featureKey: 'multiple_post_wizards',
  })

  const shouldForceUpgrade = (channel: TextChannelKey | undefined) => {
    return channel && isMultipostType(channel) && isMultiPostDisabled && nextTierPlan
  }

  return {
    shouldForceUpgrade,
    currentTierPlan,
    nextTierPlan,
  }
}
